/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { HchbCreatePatientTaskBody } from './HchbCreatePatientTaskBody';
import {
    instanceOfHchbCreatePatientTaskBody,
    HchbCreatePatientTaskBodyFromJSON,
    HchbCreatePatientTaskBodyFromJSONTyped,
    HchbCreatePatientTaskBodyToJSON,
} from './HchbCreatePatientTaskBody';
import type { HchbUploadDocumentsTaskBody } from './HchbUploadDocumentsTaskBody';
import {
    instanceOfHchbUploadDocumentsTaskBody,
    HchbUploadDocumentsTaskBodyFromJSON,
    HchbUploadDocumentsTaskBodyFromJSONTyped,
    HchbUploadDocumentsTaskBodyToJSON,
} from './HchbUploadDocumentsTaskBody';

/**
 * @type HchbTaskBody
 * 
 * @export
 */
export type HchbTaskBody = HchbCreatePatientTaskBody | HchbUploadDocumentsTaskBody;

export function HchbTaskBodyFromJSON(json: any): HchbTaskBody {
    return HchbTaskBodyFromJSONTyped(json, false);
}

export function HchbTaskBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbTaskBody {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfHchbCreatePatientTaskBody(json)) {
        return HchbCreatePatientTaskBodyFromJSONTyped(json, true);
    }
    if (instanceOfHchbUploadDocumentsTaskBody(json)) {
        return HchbUploadDocumentsTaskBodyFromJSONTyped(json, true);
    }
    return {} as any;
}

export function HchbTaskBodyToJSON(json: any): any {
    return HchbTaskBodyToJSONTyped(json, false);
}

export function HchbTaskBodyToJSONTyped(value?: HchbTaskBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfHchbCreatePatientTaskBody(value)) {
        return HchbCreatePatientTaskBodyToJSON(value as HchbCreatePatientTaskBody);
    }
    if (instanceOfHchbUploadDocumentsTaskBody(value)) {
        return HchbUploadDocumentsTaskBodyToJSON(value as HchbUploadDocumentsTaskBody);
    }
    return {};
}

